import styled from 'styled-components'
import { Modal, tokens } from '@arvoreeducacao/bonsai-ds'

export const StyledModal = styled(Modal)`
  @media (max-width: ${tokens.breakpoints.tablet}px) {
    && {
      display: flex !important;
      flex-direction: column;
      position: fixed !important;
      top: 20% !important;
      right: 0 !important;
      bottom: 0 !important;
      left: 0 !important;
      margin: 0 !important;
      height: 80dvh !important;
      max-height: 80dvh !important;
      overflow: hidden !important;
      background: ${tokens.colors.white};
      border-radius: ${tokens.radius.large} ${tokens.radius.large} 0 0 !important;
      animation: none !important;
      transform: none !important;
    }

    [data-testid='modal-content'],
    [class*='Modalstyles__ModalStyle'] {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
    }
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalLarge};
  padding: ${tokens.spacing.verticalMedium} 0;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    flex: 1;
    padding: ${tokens.spacing.verticalMedium} ${tokens.spacing.horizontalMedium};
  }
`

export const Description = styled.p<{ a11yEnabled?: boolean }>`
  margin: 0;
  color: ${({ a11yEnabled }) =>
    a11yEnabled ? tokens.colors.dark5 : tokens.colors.dark4};
  font-size: ${tokens.fontSize.medium};
  line-height: 1.5;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
`

export const FieldHelper = styled.p<{ a11yEnabled?: boolean }>`
  margin: 0;
  padding-left: ${tokens.spacing.verticalMedium};
  color: ${({ a11yEnabled }) =>
    a11yEnabled ? tokens.colors.dark5 : tokens.colors.dark4};
  font-size: ${tokens.fontSize.small};
`

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${tokens.spacing.horizontalSmall};
  margin-top: ${tokens.spacing.verticalSmall};

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    flex-direction: column-reverse;
    margin-top: auto;
  }
`

export const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${tokens.spacing.verticalMedium};
  padding: ${tokens.spacing.verticalLarge} 0;

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    padding: ${tokens.spacing.verticalLarge} ${tokens.spacing.horizontalMedium};
  }
`

export const SuccessImage = styled.img`
  height: 92px;
  width: auto;
`
